<!-- No signed-in user is passed: a project has no person to like, comment on, report or subscribe to. -->
<ut-community-feed-item [id]="'project_' + project.id" [item]="project" [user]="{}" (click)="open()">
  <!-- What the shared card has no place for: badges above, when / where the project runs between the title and the preview. -->
  @if (project.featured || project.user_has_applied) {
    <div feedItemLabel class="pcard__extras">
      @if (project.featured) {
        <span class="badge badge--brand"><span class="material-icons" aria-hidden="true">star</span>Featured</span>
      }
      @if (project.user_has_applied) {
        <span class="badge badge--success"><span class="material-icons" aria-hidden="true">check</span>Applied</span>
      }
    </div>
  }
  @if (project.start_date || project.countries?.length) {
    <div feedItemMeta class="pcard__extras">
      @if (project.start_date) {
        <span class="pcard__meta"><span class="material-icons" aria-hidden="true">event</span>Start date: {{ project.start_date | date: 'MMM dd' }}</span>
      }
      @if (project.countries?.length) {
        <span class="pcard__meta"><span class="material-icons" aria-hidden="true">location_on</span><span class="sr-only">Countries: </span>{{ project.countries.join(', ') }}</span>
      }
    </div>
  }
</ut-community-feed-item>
